/**
 * 营销日历api
 */

import request from '@/utils/request'
import qs from 'qs'


/**
 * 日历信息
 * @param data
 * @returns {AxiosPromise}
 */
export function getCalendar(data) {
  return request({
    url: '?m=Api&a=marketingCalendar',
    method: 'post',
    data:qs.stringify(data)
  })
}
// 营销日历接口 api.chaopx.com/?m=Api&a=marketingCalendar   post提交
// 参数 year 年  month 月  type 事件类型


/* 设置日历日程 */
export function setCalendarCustomSchedule(data) {
  return request({
    url: '?m=Auxfun&a=customCalendarCreate',
    method: 'post',
    data:qs.stringify(data)
  })
}

/* 取消日历日程 */
export function deleteCalendarCustomSchedule(data) {
  return request({
    url: '?m=Auxfun&a=customCalendarCancel',
    method: 'post',
    data:qs.stringify(data)
  })
}



export function statCalendar(query) {
  return request({
    url: '?m=StatApi&a=calender',
    method: 'get',
    params: query
  })
}
